import { Loading } from 'element-ui'
import NProgress from 'nprogress'

let loadingCount = 0
let loading
let timer
let readCount = 0

export const showReadLoading = () => {
  if (readCount++ === 0) NProgress.start()
}

export const hideReadLoading = () => {
  if (readCount > 0 && --readCount === 0) NProgress.done()
}

const startLoading = () => {
  loading = Loading.service({
    lock: true,
    text: '正在处理…',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0)'
  })
}

const endLoading = () => {
  clearTimeout(timer)
  timer = null
  if (loading) {
    loading.close()
    loading = null
  }
}

export const showLoading = () => {
  if (loadingCount === 0) {
    timer = setTimeout(() => {
      timer = null
      if (loadingCount > 0) startLoading()
    }, 300)
  }
  loadingCount += 1
}

export const hideLoading = () => {
  if (loadingCount <= 0) {
    return
  }
  loadingCount -= 1
  if (loadingCount === 0) {
    endLoading()
  }
}



// WEBPACK FOOTER //
// ./src/utils/loading.js